/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CustomerSessionQueryVariables = Exact<{ [key: string]: never }>;

export type CustomerSessionQuery = {
  readonly customerPaymentInfo: {
    readonly __typename: 'CustomerPaymentInfo';
    readonly id: string;
    readonly paymentSessionId: string;
  };
};

export const CustomerSessionDocument = gql`
  query CustomerSession {
    customerPaymentInfo {
      id
      paymentSessionId
      __typename
    }
  }
`;

export function useCustomerSessionQuery(
  options?: Omit<Urql.UseQueryArgs<CustomerSessionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomerSessionQuery, CustomerSessionQueryVariables>({
    query: CustomerSessionDocument,
    ...options,
  });
}
